// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"L2-z"};